import React from 'react';
//<88181> 
const ListadoCaracTecVehiculoDinamico = props => (
	<div className="card card-plain card-lg">
		<div className="wrapper tableFdv">
			<div align="right">
				<button className="btn btn-blue-p" onClick={props.agregarParametrosCT} style={{ width: "160px", marginRight: "15px" }}>
					Agregar Características
				  </button>
				<button className="btn btn-orange-p" onClick={() => props.grabarParametroCT()} style={{ width: "95px" }}>
					Guardar
				  </button>
			</div>
			<br />
			<div className="tableWrapper" style={{ border: "1px solid #e5e5e5" }}>
				<table className="table table-hover" style={{ marginBottom: "100px" }}>
					<tbody>
						{
							props.arrecaractecn.length ?
								props.arrecaractecn.map((arreglo, index) => (
									<tr key={index}>
										<td style={{ borderTop: "none" }}>
											<div className='wrapper'>

												<div className='row'>
													<div className='col-md-1'>
														<label className='labelInfo' htmlFor={`p_codigo_` + index}>Codigo</label>
													</div>
													<div className='col-md-1'>
														<label className='labelInfo' htmlFor={`p_nroorden_` + index}>Orden</label>
													</div>
													<div className='col-md-2'>
														<label className='labelInfo' htmlFor='carTect'>Caract. Tecnica</label>
													</div>
													<div className='col-md-3'>
														<label className='labelInfo' htmlFor='Valor'>Valor</label>
													</div>
													<div className='col-md-1'>
														<label className='labelInfo' htmlFor='Imprimir'>Imprimir</label>
													</div>
													<div className='col-md-1'>
														<label className='labelInfo' htmlFor='Inactivo'>Inactivo</label>
													</div>
													<div className='col-md-1'>
														<label className='labelInfo' htmlFor={`p_indImpWeb_` + index}>Web</label>
													</div>
													<div className='col-md-2'>
														<label className='labelInfo' htmlFor={`p_numOrdenWeb_` + index}>Orden Web</label>
													</div>
												</div>

												<div className='row'>
													<div className='col-md-1'>
														<input className='form-control'
															id={`p_codigo_` + index}
															name={`p_codigo`}
															type='text'
															onChange={e => props.onUpdateItem(e, index)}
															readOnly={true}
															defaultValue={arreglo.codCarTec} />
													</div>
													<div className='col-md-1'>
														<input className='form-control'
															readOnly={arreglo.codCarTec == '' ? true : false}
															id={`p_nroorden_` + index}
															name={`p_nroorden`}
															type="number"
															step="1"
															min="1"
															max="100"
															required
															onChange={e => props.onUpdateItem(e, index)}
															defaultValue={arreglo.numeroOrden} />
													</div>

													<div className='col-md-2'>
														{(arreglo.codCarTec != '') ? (
															<select
																id="carTect"
																name="carTect"
																className="form-control input-sm"
																onChange={e => props.onUpdateItem(e, index)}
																disabled={arreglo.codCarTec != '' ? true : false}
																readOnly={arreglo.codCarTec != '' ? true : false}
																value={arreglo.codCarTec}>
																<option disabled value=''>SELECCIONE</option>
																{props.arretbcaractec.map((c, i) => (
																	<option key={i} value={c.codigo}>{c.descripcion}</option>
																))}
															</select>
														) : (
																<select
																	id={`p_cartec_` + index}
																	name={`p_cartec`}
																	className="form-control input-sm"
																	onChange={e => props.onUpdateItem(e, index)}
																	disabled={arreglo.codCarTec != '' ? true : false}
																	readOnly={arreglo.codCarTec != '' ? true : false}>
																	defaultValue={arreglo.codCarTec}>
																	<option value='0'>Seleccione</option>
																	{props.arretbcaractec.map((c, i) => (
																		<option key={i} value={c.codigo}>{c.descripcion}</option>
																	))}
																</select>
															)}
													</div>

													<div className='col-md-3'>
														<input className='form-control' id={`p_valor_` + index} name={`p_valor`} type='text'
															onChange={e => props.onUpdateItem(e, index)}
															defaultValue={arreglo.valor} />
													</div>
													<div className='col-md-1'>
														<input id={`p_imprimir_` + index} name={`p_imprimir`} type='checkbox'
															onChange={e => props.onUpdateItem(e, index)}
															defaultChecked={arreglo.indImpreso === 'S' ? true : false} />
													</div>
													<div className='col-md-1'>
														<input id={`p_inactivo_` + index} name={`p_inactivo`} type='checkbox'
															onChange={e => props.onUpdateItem(e, index)}
															defaultChecked={arreglo.indInactivo === 'S' ? true : false} />
													</div>

													<div className='col-md-1'>
														<input id={`p_indImpWeb_` + index} name={`p_indImpWeb`} type='checkbox'
															onChange={e => props.onUpdateItem(e, index)}
															defaultChecked={arreglo.indImpWeb === 'S' ? true : false} />
													</div>
													<div className='col-md-1'>
														<input className='form-control'
															id={`p_numOrdenWeb_` + index}
															name={`p_numOrdenWeb`}
															type="number"
															step="1"
															min="1"
															max="100"
															required
															onChange={e => props.onUpdateItem(e, index)}
															defaultValue={arreglo.numOrdenWeb} />
													</div>
													<div className='col-md-1'>
														<button className="btn btn-red-p"
															onClick={(e) => {
																if (window.confirm('¿ Esta seguro que desea eliminar este registro?'))
																	props.eliminarParametrosCT(e, index, arreglo.codCarTec)
															}} style={{ width: "95px" }}>
															Eliminar
                                                    </button>
													</div>
												</div>
											</div>
										</td>
									</tr>
								)) :
								<tr>
									<td colSpan={6}>No hay resultados</td>
								</tr>
						}
					</tbody>
				</table>
			</div>
		</div>
	</div>
);

export default ListadoCaracTecVehiculoDinamico;







// WEBPACK FOOTER //
// ./src/pages/MantSkuVehiculo/ListadoCaracTecVehiculoDinamico.js